class GameUtils {
  static getParameterByName = function (name, url) {
    if (!url) url = window.location.href
    name = name.replace(/[\]]/g, '\\$&')
    // name = name.replace(/[\[\]]/g, '\\$&');  old
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    const results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }
}
export default GameUtils